import React from 'react';
import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';
import { Tag } from 'antd';

export default function EventTypeTag({ value }) {
  const { t } = useTranslation();
  return (
    <Tag color="default">
      { t(value) }
    </Tag>
  );
}

EventTypeTag.propTypes = {
  value: PropTypes.string.isRequired,
};
